
/* Ingredients modal */
(function () {
  const TEXTS = ['ingredients', 'ingredientai'];

  function getModal() {
    return document.querySelector('[id^="ingredients-modal-"]');
  }

  function openModal(modal) {
    modal.classList.remove('hidden');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.classList.add('hidden');
    document.documentElement.style.overflow = '';
  }

  function wireModalBasics(modal) {
    if (!modal || modal.dataset.bound === '1') return;
    modal.dataset.bound = '1';
    const backdrop = modal.querySelector('.ingredients-backdrop');
    const closeBtn = modal.querySelector('.ingredients-close');
    closeBtn?.addEventListener('click', () => closeModal(modal));
    backdrop?.addEventListener('click', () => closeModal(modal));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal(modal);
    });
  }

  function shouldBindRow(row) {
    const heading = row.querySelector('.feature-chart__heading');
    if (!heading) return false;
    const t = (heading.textContent || '').trim().toLowerCase();
    return TEXTS.some(x => t.includes(x));
  }

  function bindRow(row, modal) {
    if (!modal) return;
    if (row.dataset.ingredientsBound === '1') return;
    const link = row.querySelector('.feature-chart__value p a');
    if (!link) return;
    row.dataset.ingredientsBound = '1';
    link.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(modal);
    });
  }

  function scanAndBind() {
    const modal = getModal();
    if (!modal) return;
    wireModalBasics(modal);
    document.querySelectorAll('.feature-chart__table-row').forEach((row) => {
      if (shouldBindRow(row)) bindRow(row, modal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndBind);
  } else {
    scanAndBind();
  }

  const mo = new MutationObserver(() => scanAndBind());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();